import { createSelector } from '@ngrx/store';
import { getUser } from './auth.selectors';

export const getUserProfile = createSelector(
  getUser,
  u => u as any,
);

export const DEFAULT_USER_PROFILE_PHOTO_URL = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACe0lEQVR4Xu2bsU4bQRCG55DlgMAvgAINDb1n7Z5IvAB5gbwAHSUU0NGmzxskL4AUd5Yl35YuItERKQ+AlFOQ7EG2ZOs4bOO7+2fD3a7r272db76Z2z3bEXn+iTyPnwKAYIDnBEIJeC6A2yY4GAw+NhqNh3XQmdmplU5u1uv1tlutVpLHNlcg1AHEcSx5Ak9f6wKCKoAywc9BaENQA4AI3gUEFQDW2raIxEXVXzZOywQVAMjsp2A8MfMHJNTpXHAASsHP4tawoFIAoij63m63PyMtqBQADQugADT113oiBADIenJhABEJM2+h1l05A9B9IABAqTSdx1EJQPcDwYBgAJCAixIQka/GmHPUsitXAujzQACAUmk6z3A4TKIo2kbOmZ3rXRvg4lHoNQAR+WGMOUMaBu0B2gags6/yRsha+0VEviGzpHUUVgGgaMEVM9+gwcJLQAuAhv5qBihAuGPmU3T2tQH8I6ImYtFa2VcFgLJAM3h1AGUhaAcfAGh8M5St+TJH5LoYcE9ER0WaYV0A+PsDidAES74pFpGeMeakSPlsOkZlKzy/eZkGqHkASsNRA4AIPrXQ38x8sGlW81wHB9Dv93eazebfPIvY9FqNpwIUADjrS7mgIUAAuAg8SwMFojCA/xH0qlIZj8efut3uz01LqVATHI1Ge0mSPBa5iesxeex404A4jq+J6NJ1EKD7vfljirUA3pPmZYCsM2IlgLoEPwcnIsfGmF9ZkEsB1C34dbvKVwDqGvwqCN4BIKJdZl7sVF8AqHv2l1kQAKS7oi8GTCaTw06nM/vz1sIAa+2FiNyWed5Waex8b7AA4Ev2s33AWwBEtM/Mf54BCAkRUO0UTLcAAAAASUVORK5CYII=';

export const getUserProfileImage = createSelector(
  getUserProfile,
  profile => (profile && profile.photoURL) || DEFAULT_USER_PROFILE_PHOTO_URL
);

export const getUserProfileFirstname = createSelector(
  getUserProfile,
  profile => (profile && profile.firstname) || null
);

export const getUserProfileLastname = createSelector(
  getUserProfile,
  profile => (profile && profile.lastname) || null
);

export const getUserProfileEmail = createSelector(
  getUserProfile,
  profile => (profile && profile.email) || null
);

export const getUserProfileUsername = createSelector(
  getUserProfile,
  profile => (profile && profile.username) || null
);

export const getUserProfileFullName = createSelector(
  getUserProfileFirstname,
  getUserProfileLastname,
  (firstname, lastname) => [firstname, lastname].filter(Boolean).join(' ') || null,
);

export const getUserProfileName = createSelector(
  getUserProfileUsername,
  getUserProfileFullName,
  getUserProfileEmail,
  (username, fullname, email) => username || fullname || email,
);

export const getUserProfileSettings = createSelector(
  getUserProfile,
  profile => (profile && profile.settings) || {}
);
